
import { ReactNode, useCallback } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";
import { useCookies } from "react-cookie";

export enum Status {
  NOTHING, // Status= 0
  LOADING, // Status= 1
  LOADED, // Status= 2
  ERROR,
}

export default interface Session {
    status: Status,
    error_reason: string,
    cookie: {
        name: string,
        value: string,
    }
    email: string,
    ownerId: string,
    is_admin: boolean,
    is_onboarded: boolean,
}

const SessionContext = createContext<Session>({
    status: Status.NOTHING,
    error_reason: "",
    cookie: {
        name: "",
        value: "",
    },
    email: "",
    ownerId: "",
    is_admin: false,
    is_onboarded: true,
});

interface SessionProviderProps {
  children: ReactNode;
  cookie_name: string;
}

let doOnce = 0;

export function SessionProvider({children, cookie_name = "dpp_session"}: SessionProviderProps) {
    
  const [cookies] = useCookies([cookie_name]);

  const [session, setSession] = useState<Session>({
    status: Status.LOADING,
    error_reason: "",
    cookie: {
      name: cookie_name,
      value: cookies[cookie_name],
    },
    email: "",
    ownerId: "",
    is_admin: false,
    is_onboarded: false,
  });

   
    useEffect(() => {
        // check, if there is any session
        if(doOnce === 0 && cookies[cookie_name]) {
            doOnce = 1
            let actualSession: Session = {
                status: Status.LOADING,
                error_reason: "",
                cookie: {
                    name: cookie_name,
                    value: cookies[cookie_name],
                },
                email: "",
                ownerId: "",
                is_admin: false,
                is_onboarded: false,
            }

            // get session information
            fetch('/api/v1/account_info').then(resp => resp.json()).then((obj) => {
               
                 actualSession = {
                    status: Status.LOADED,
                    cookie: {
                        name: cookie_name,
                        value: cookies[cookie_name],
                    },
                    error_reason: "",
                    email: obj.email,
                    is_admin: obj.is_admin,
                    is_onboarded: obj.is_onboarded,
                    ownerId: obj.owner_id,
                }
                setSession(actualSession)
            }).catch((reason: any) => {
                setSession({
                    status: Status.ERROR,
                    error_reason: reason,
                    cookie: {
                      name: cookie_name,
                      value: cookies[cookie_name],
                    },
                    email: "",
                    is_admin: false,
                    is_onboarded: false,
                    ownerId: "",
                })
                doOnce = 0
            })

        } else if(!cookies[cookie_name]) {
            setSession({
                status: Status.NOTHING,
                error_reason: "no session",
                cookie: {
                  name: cookie_name,
                  value: cookies[cookie_name],
                },
                email: "",
                ownerId: "",
                is_admin: false,
                is_onboarded: false,
            })
        }
    }, [])

  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
}

export const useSession = () => useContext(SessionContext);
